import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getCookie } from './utils/cookieUtils';
import translationEn from 'assets/locals/en/translation.json';
import translationDe from 'assets/locals/ger/translation.json';
import { SELECTED_LANGUAGE } from 'utils/enums/misc';

const Languages = ['en', 'ger'];
// const language = getCookie("lang");
const language = getCookie(SELECTED_LANGUAGE);
i18n

  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEn
      },
      de: {
        translation: translationDe
      }
    },
    lng: language || 'de',
    fallbackLng: 'de',
    debug: true,
    whiteList: Languages,

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
